import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { fromEvent } from 'rxjs';
import { debounceTime, filter, switchMap } from 'rxjs/operators';
import { ResponseUSer } from 'src/app/_models';
import { AuthenticationService, EncrDecrService } from 'src/app/_services';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css'],
})
export class MenuComponent implements OnInit,OnDestroy,AfterViewInit {
  Menu = true;
  Admin=false;
  Customer=false;
  Werehouse=false;
  mySubscription: any;
  currentUser: ResponseUSer;
  isLDT=false;
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private EncrDecr: EncrDecrService,
    
  ) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((events) => {
      this.authenticationService.currentUser.subscribe(x => this.currentUser = x);


    });
     this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    this.mySubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        console.log("ddddd")
        // Trick the Router into believing it's last link wasn't previously loaded
        this.router.navigated = true;
      }
    }) 
	if (this.authenticationService.currentUserValue.company=='LDT20') {
		this.isLDT=true;
	}

  }
  ngAfterViewInit(): void {
    console.log("afeter")
    const main =  <HTMLInputElement>document.getElementById('SubMenu');


    fromEvent(main, 'mouseenter')
    .pipe(   
      switchMap(event => {
        console.log('show');
        main.style.display = 'block';
        return fromEvent(main, 'mouseleave').pipe(debounceTime(500));
      })
      )
    .subscribe(val => {
     console.log('hide');
     main.style.display = 'none';
   });
 /*  var dd=localStorage.getItem("header");
    if (dd == "1") {
      var element = document.getElementById('SubMenu');
      element.style.display = 'none';
     // this.dd.Menu=false;
    
      localStorage.setItem('header', '1');
    } else { */
//this.dd.Menu=true;
      
  //  }
   
   
  }
  ngOnDestroy(): void {
    
    if (this.mySubscription) {
      
      this.mySubscription.unsubscribe();
     
    }

  }
  ngOnInit(): void {
  

    
    if (this.authenticationService.currentUserValue) {
      if(this.authenticationService.currentUserValue.rol=="AdministradorEmpresa"){
        this.Admin=true;
      
      }else  if(this.authenticationService.currentUserValue.rol=="CustomerEmpresa"){
        this.Customer=true;
      }else  if(this.authenticationService.currentUserValue.rol=="WarehouseEmpresa"){
        this.Werehouse=true;
      }
    }
    var element = document.getElementById('SubMenu');
    element.style.display = 'none';
  
    localStorage.setItem('header', '0');
  }
  step = 23;

  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
  }
  OnSalir() {
    this.authenticationService.logout();
  }
  On3placceso(data: any) {
    if (data == '1') {
      var users = localStorage.getItem('LogAutUs');
      var pass = localStorage.getItem('LogAutPas');
      var url='https://parking.3plfreightsoftware.com/login?LoUss=' +
      encodeURIComponent(users) +
      '&LoUssPass=' +
      encodeURIComponent(pass);

      window.open(url, '_blank');
     
        
    }
  }
}
